import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class PublicUtilityMapperError extends IncError {
    constructor() {
        super(i18n.t("error:entity.publicUtility.publicUtilityMapperError"));

        Object.setPrototypeOf(this, PublicUtilityMapperError.prototype);
    }
}